<template>
    <!-- Hide the whole FAQ block when there are no responses; filteredList is an array and always truthy. -->
    <div class="answers" v-if="defaultResponses.length">
            <div tabindex="0" aria-live="assertive">{{$gettext('O encuentra respuestas')}}:</div>
            <div class="action-wrapper">
                <input 
                    :placeholder="$gettext('Buscar...')" 
                    v-model="search"
                    name="searchInput">
                <!-- <div class="icon-wrapper">
                    <i class="input-icon icon-chevron-right"></i>
                </div> -->
            </div>
            <div class="answersList">

                <type-answers
                v-for="type in filteredList"
                :key="type.id"
                :type="type">
            </type-answers>
        </div>
    </div>
</template>

<script>
import TypeAnswers from '../TypeAnswer.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'DefaultResponses',
    data(){
        return{
          search: ''
        }
    },
    components: {
        TypeAnswers
    },

    computed: {
        ...mapGetters(['defaultResponses']),
        filteredList() {
          const normalizeString = (str) =>
              str
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase();

          const searchNormalized = normalizeString(this.search);

          return this.defaultResponses.filter((post) => {
            const combinedText = `${post.question} ${post.answer}`;
            return normalizeString(combinedText).includes(searchNormalized);
          });
        },
    },
    
}


</script>
